import {collection, component, field, identifier} from "@fedeltapointofsale/data-client";
import {PricingScheduleData} from "../pricing-schedule/pricing-schedule.data";
import {SpecialReferenceData} from "../special/special.data";
import {TypedTerminalReferenceData} from "../../pos/terminal/terminal-reference.data";

export class SpecialScheduleData extends PricingScheduleData<SpecialScheduleData> {
    @identifier specialScheduleId: number;
    @field name: string;
    @field allTerminals: boolean = false;
    @field discontinued: boolean;
    @component special: SpecialReferenceData;
    @collection(TypedTerminalReferenceData) terminals: TypedTerminalReferenceData[];
}
